import { rawModules } from "./listConstants";

export const SERVER = process.env.REACT_APP_BACKEND_ENDPOINT;
export const NEW_ITEM_ID = 0

export const MANUAL_API_ENDPOINTS = {
    AITREE: {
        CHATS: '/chats/',
        API_ASSIGNMENTS_FOR_STAGE: (stageId) => `/aitrees/api_assignments_for_stage/${stageId}`,
        PROMPT_FOR_STAGE: (stageId) => `/aitrees/prompts/${stageId}`,
        STAGE_CONNECT: (chatId) => `/aitrees/stage_connect/${chatId}`,
        STAGES: (chatId) => `/aitrees/stages/${chatId}`,
        IMPORT: (chatId) => `/aitrees/import/${chatId}`
    },
    APPS: {
        LIST: '/apps/',
    },
    AVATARS: {
        FILE_UPLOAD: '/avatars/avatars',
        IMAGE_FOLDER: '/../public/avatars/',
        VIDEOS: '/avatars/avatars/videos', 
        ACTIVE: '/avatars/avatars/active',
        ALL: '/avatars/avatars',
    },  
    CHATS: {
        CHAT_PARAMS: (chatId) => `/chats/${chatId}/params`,
        CONDITION_OPTIONS: (chatId) => `/chats/${chatId}/conditions`,
        MEDIA: (chatId) => `/chats/${chatId}/medias`,
    },
    COMMUNICATION_PLANS: {
        STEPS: (id) => `/communication_plans/${id}/steps`,
        PARTICIPANTS: (id) => `/communication_plans/${id}/participants`,
    }, 
    CUSTOMERS: {
        CATEGORIES: '/customer/categories',
        ADDRESSES: (customerId) => `/customer/${customerId}/addresses`,
        EMAIL_ADDRESSES: (customerId) => `/customer/${customerId}/email_addresses`,
        PHONE_NUMBER: (customerId) => `/customer/${customerId}/phone_numbers`,
        INTERACTIONS: (customerId) => `/customer/${customerId}/interactions`,
        COMPANY_RELATION: (customerId) => `/customer/${customerId}/company_relation`,
        AI_FILL: (customerId) => `/customer/${customerId}/ai/fill`,
        AI_SUMMARY: (customerId) => `/customer/${customerId}/ai/summary`,
        AI_SUGGESTIONS: (customerId) => `/customer/${customerId}/ai/suggestions`,
        AI_REVISE: (customerId) => `/customer/${customerId}/ai/revise`,
        METRICS: (customerId) => `/customer/${customerId}/metrics`,
    },
    EMAILS: {
        ATTACHMENTS: (emailId, uploadId) => `/email/${emailId}/attachment/${uploadId}`,
        SIGNATURES: {
            ALL: '/email/signatures',
            DEFAULT: '/email/signatures/default',
            DEFAULTS: '/email/signatures/defaults',
        },
        SEND: (id) => `/email/${id}/send`,
    },
    ACCOUNT_SETTINGS: {
        CONNECT: (id) => `/account-settings/${id}/connect`,
        LINKEDIN_REFRESH: (id) => `/account-settings/${id}/linkedin/refresh`,
        LINKEDIN_AUTH: (id) => `/account-settings/${id}/linkedin/start_linkedin_auth`,
        LINKEDIN_DELETE: (id) => `/account-settings/${id}/linkedin/delete_linkedin_auth`
    },
    EVENTS: {
        PARTICIPANTS: (id) => `/events/${id}/participants`,
        FILTER_TREE: (id) => `/events/${id}/filter_tree`,
        EXECUTE_FILTER_TREE: (id) => `/events/${id}/filter_tree/execute`,
    },
    FILTER_TREE: {
        ITEM: (id) => `/events/filter_tree/${id}`
    },
    INTEGRATIONS: {
        EXECUTE_API: (id) => `/integrations/${id}/trigger`,
    },
    KNOWLEDGE: {
        PROCESS: (id) => `/knowledge/${id}/process`
    },
    METADATA: {
        OBJ: (obj) => `/metadata/obj/${obj}`,
    },
    OBJECT: {
        SEARCH: '/roles/object/search',
        ITEM: (objectId) => `/roles/object/${objectId}` 
    },
    ORDERS: {
        LINE_ITEMS: (id) => `/order/${id}/line_items`,
    },
    PRODUCTS: {
        CROSS_SELL: (id) => `/products/${id}/cross_sell`,
    },
    REPORTS: {
        AI_USAGE: '/reports/token_usage',
        EMAILS: '/reports/emails',
        COMPANIES: '/reports/companies',
        ELEVENLABS: '/reports/elevenlabs',
    },
    SETTINGS: {
        APIS: '/api/data/apis',
        USER_SETTINGS: '/api/data/user_settings'
    },
    TENANTS: {
        CURRENT: '/tenants/current',
    },
    UPLOADS: {
        FILE: (file_name) => `/upload/files/${file_name}`,
        DOWNLOAD: (id) => `/upload/files/id/${id}`,
        ANALYZE: (uploadId) => `/upload/${uploadId}/analyze`,
        FILE_UPLOAD: (uploadId) => `/upload/file_upload/${uploadId}`,
        IMPORT_DATA: (uploadId) => `/upload/${uploadId}/imports`
    },
    ROLES: {
        PERMISSIONS: (roleId) => `/roles/${roleId}/permissions`,
        PERMISSIONS_SHORTCUT: (roleId) => `/roles/${roleId}/permissions/shortcut`
    },
    USERS: {
        USER_ROLES: (TenantUserId) => `/users/${TenantUserId}/roles`,
        TENANT_USER: (tenantUserId) => `/users/tenant/${tenantUserId}`,
        ID: '/users/user',
        INVITATIONS: '/users/invitations',
        VALIDATE_INVITATION: '/users/validate-invitation',
        ACCEPT_INVITATION: '/users/accept-invitation',
        ADDRESSES: (id) => `/users/${id}/addresses`,
        SELECT_TENANT: (tenantId) => `/users/select_tenant/${tenantId}`,
    }
};

export const generatedApiEndpoints = Object.fromEntries(
        rawModules.filter(mod => mod.route !== null).map(({ key, route }) => {
            const KEY = key.toUpperCase()
            const manual = MANUAL_API_ENDPOINTS[KEY] || {}; 
            return [
                KEY,
                {
                    ITEM: manual.ITEM || ((id) => `${route}${id}`),
                    LIST: manual.LIST || `${route}`,
                    SYNC: manual.SYNC || `${route}sync`,
                    SEARCH: manual.SEARCH || `${route}search`,
                    ...manual,
                },
            ];
        })
);

export const API_ENDPOINTS = {
    ...MANUAL_API_ENDPOINTS,
    ...generatedApiEndpoints,
};